import axios from 'axios';
import { api } from 'lib/src/utils/api';
import fileDownload from 'js-file-download';
import dayjs from 'dayjs';
import {
    Challenge,
    CalendarChallenge,
    FormattedDate,
    LookupObject,
} from 'src/types/shared/Challenge';

export const downloadCSV = async (url: string, filename?: string) => {
    try {
        const csv = await api.get<string>(url);

        const aElement = document.createElement('a');
        aElement.href = `data:text/csv;charset=utf-8,${escape(csv.data)}`;
        if (filename) aElement.download = filename;

        document.body.appendChild(aElement);
        aElement.click();
        document.body.removeChild(aElement);
    } catch (_err) {}
};

export const downloadFile = (url: string, fileName: string) => {
    axios({
        url,
        method: 'GET',
        responseType: 'blob',
    })
        .then(res => {
            fileDownload(res.data, fileName);
        })
        .catch(e => {
            console.log({ e });
        });
};

export const getDateRange = (startDate: Date, endDate: Date) => {
    // take two date objects and return an array of formatted date strings for each day between the two dates inclusive
    let _startDate = dayjs(startDate);
    const _endDate = dayjs(endDate);

    const dateRange: string[] = [];

    while (_startDate <= _endDate) {
        dateRange.push(_startDate.format('YYYY-MM-DD'));
        _startDate = _startDate.add(1, 'day');
    }

    return dateRange;
};

export const getMonthsFromDates = (dates: FormattedDate[]) => {
    // Turn a formatted date array into an array of month objects with from & to dates
    const result: Record<string, LookupObject> = {};

    dates.forEach(date => {
        const { y, m, d } = date;
        const key = `${y}-${m}`;
        if (!result.hasOwnProperty(key)) result[key] = { from: date, to: date };
        else {
            if (+result[key].from.d > +d) result[key].from = date;
            if (+result[key].to.d < +d) result[key].to = date;
        }
    });

    const sortedResult = Object.values(result).sort((a, b) => {
        if (+a.from.y === +b.from.y) return +a.from.m - +b.from.m;
        return +a.from.y - +b.from.y;
    });

    return sortedResult;
};

export const getDateRangeFromChallenge = (challenge: Challenge | CalendarChallenge) => {
    const dates = [
        { name: 'startDate', value: dayjs(challenge.startDate || undefined).valueOf() },
        { name: 'endDate', value: dayjs(challenge.endDate).valueOf() },
        { name: 'workshopDate', value: dayjs(challenge.workshopDate).valueOf() },
        { name: 'responseDate', value: dayjs(challenge.responseDate).valueOf() },
        { name: 'assessmentStartDate', value: dayjs(challenge.assessmentStartDate).valueOf() },
        {
            name: 'pitchPresentationDate',
            value: dayjs(challenge.pitchPresentationDate).valueOf(),
        },
    ];
    const earliest = dates.reduce((prev, curr) => {
        return prev.value < curr.value ? prev : curr;
    });
    const latest = dates.reduce((prev, curr) => {
        return prev.value > curr.value ? prev : curr;
    });
    return { start: dayjs(earliest.value), end: dayjs(latest.value) };
};

export const arrayToQueryString = (array: string[] | number[], key: string) => {
    return array.map(val => `${key}=${val}`).join('&');
};

export const removeDuplicatesFromArray = (array: Array<number>) => {
    const result: Array<number> = [];
    array.forEach(item => {
        if (result.indexOf(item) < 0) result.push(item);
    });
    return result;
};
